import { readSequenceHead } from '../../Util/orderSettingDetection/sequenceHead.ts'
import { fileRuns } from '../../Util/orderSettingDetection/sequencingRunDetection.ts'

/* bundled into the detection worker: no DOM, store or path-alias imports */

export type RunsRequest = { files: { key: string; blob: Blob }[] }

export type RunsResult = { runs: Record<string, string> }

const HEADERS_PER_FILE = 20

/** Each file's sequencing run from its first read headers; `''` when they name none. */
export const runRuns = async (request: RunsRequest): Promise<RunsResult> => {
  const entries = await Promise.all(
    request.files.map(async ({ key, blob }) => {
      const reads = await readSequenceHead(blob, HEADERS_PER_FILE)
      return [key, fileRuns(reads.map((read) => read.header)).keys[0] ?? ''] as const
    })
  )
  return { runs: Object.fromEntries(entries) }
}
